module.exports = __webpack_public_path__ + "static/media/BM_Training.35f98002.svg";